import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPostmanComponent } from './simple-icons-postman.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPostmanComponent ],
    exports:      [ SimpleIconsPostmanComponent ],
    bootstrap:    []
})
export class SimpleIconsPostmanModule {}
